export const BASE_URL = 'https://edunix-store-api.beetronix.net/api'